<!--
 * @Description: 发票邮寄
 * @Date: 2025-05-20 15:57:04
-->
<template>
  <BaseForm ref="formRef" label-position="top" disabled :model="formData">
    <div class="form-dialog__title">
      <h1>发票邮寄</h1>
    </div>
    <div class="form-dialog__content">
      <BaseFormItem label="收件人" prop="receiptFullName">
        <BaseInput
          class="form-dialog__w280"
          type="text"
          placeholder="请输入"
          :modelValue="formData.receiptFullName"
        ></BaseInput>
      </BaseFormItem>
      <BaseFormItem label="联系电话" prop="receiptPhone">
        <BaseInput
          class="form-dialog__w280"
          type="text"
          placeholder="请输入"
          :modelValue="formData.receiptPhone"
        ></BaseInput>
      </BaseFormItem>
      <BaseFormItem label="企业地址" prop="invoiceEnterpriseAddress">
        <BaseInput
          class="form-dialog__w280"
          type="text"
          placeholder="请输入"
          :modelValue="formData.invoiceEnterpriseAddress"
        ></BaseInput>
      </BaseFormItem>
      <BaseFormItem label="邮箱" prop="email">
        <BaseInput
          class="form-dialog__w280"
          type="tel"
          placeholder="请输入"
          :modelValue="formData.email"
        ></BaseInput>
      </BaseFormItem>
    </div>
  </BaseForm>
</template>

<script lang="tsx" setup>
import { defineModel } from 'vue';
import { BaseForm, BaseFormItem, BaseInput } from 'xrk-components';
import { InvoiceApplyDTO } from '@V/invoice/src/data-source/types';

const formData = defineModel<InvoiceApplyDTO>();
</script>
